'use client';

import { GenericError } from '@shared/components';
import { ROUTES } from '@shared/utils';
import { useTranslations } from 'next-intl';

function Error() {
  const t = useTranslations('errors.generic');

  return (
    <main className="ll-grid-container my-20">
      <GenericError title={t('title')} subtitle={t('subtitle')} cta={{ link: ROUTES.HOME, text: t('button_home') }} altText={t('image_alt')} />
    </main>
  );
}
export default Error;
